import React from "react";
import ReactDOM from "react-dom/client";
import "@shopify/polaris/build/esm/styles.css";
import { AppProvider as PolarisProvider } from "@shopify/polaris";
import enTranslations from "@shopify/polaris/locales/en.json";
import App from "./App";

// App Bridge (Shopify admin embedding) gets wired up in milestone 6 once we have
// a Shopify API key. For now Polaris alone is enough to develop the UI.

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <PolarisProvider i18n={enTranslations}>
      <App />
    </PolarisProvider>
  </React.StrictMode>
);
